import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import JuiceButton from "@/components/JuiceButton";
import Landing from "@/pages/Landing";
import Participant from "@/pages/Participant";
import Results from "@/pages/Results";

function Shell({ children }) {
  return (
    <div className="min-h-screen w-full bg-[#fff9ed] relative overflow-x-hidden">
      {/* Grid background */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />
      {/* Top bar */}
      <header className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 pt-6 pb-2 flex items-center justify-between">
        <a
          href="/"
          data-testid="brand-link"
          className="inline-flex items-center gap-3 neo-heading text-2xl tracking-tight"
        >
          <img
            src="/grapefruit-logo.png"
            alt=""
            aria-hidden="true"
            className="block w-9 h-9 object-cover rounded-md border-[2px] border-black shadow-[2px_2px_0_0_#000]"
          />
          Grapefruit.win
        </a>
        <JuiceButton />
      </header>

      <main className="relative z-10 max-w-5xl mx-auto px-3 sm:px-6 py-6 sm:py-12 flex items-start justify-center">
        {children}
      </main>

      <footer className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-6 text-center font-mono text-[11px] text-black/50">
        easy to use, forever (c) {new Date().getFullYear()}
      </footer>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/m/:id" element={<Participant />} />
            <Route path="/m/:id/results" element={<Results />} />
            <Route path="/admin/:id" element={<Results adminMode />} />
          </Routes>
        </Shell>
        <Toaster
          position="bottom-center"
          toastOptions={{
            className:
              "!border-[2px] !border-black !rounded-lg !shadow-[4px_4px_0_0_#000] !font-mono !text-sm",
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
